import { CommentOutlined, SendOutlined } from "@ant-design/icons";
import { FloatButton } from "antd";
import { useState } from "react";
import SupportTicketDrawer from "./SupportTicketDrawer";

const SupportFloatButton = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <span
        data-tour-id="support-float-button"
        aria-hidden
        style={{
          position: "fixed",
          insetInlineEnd: 24,
          bottom: 24,
          width: 40,
          height: 40,
          pointerEvents: "none",
        }}
      />
      <FloatButton.Group trigger="click" icon={<CommentOutlined />} style={{ insetInlineEnd: 24 }}>
        <FloatButton
          icon={<SendOutlined />}
          tooltip="Открыть @aismetrica_bot"
          onClick={() => window.open("https://t.me/aismetrica_bot", "_blank")}
        />
        <FloatButton
          icon={<CommentOutlined />}
          tooltip="Написать в поддержку"
          onClick={() => setDrawerOpen(true)}
        />
      </FloatButton.Group>
      <SupportTicketDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
  );
};

export default SupportFloatButton;
